import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AUTH_STORAGE_KEY } from '../features/auth/constants';

import { createLogger } from '../utils/logger';
const logger = createLogger('hooks');

/**
 * Hook para proteger componentes que requieren autenticación
 * Redirige automáticamente al login si no hay token válido
 */
export const useAuthGuard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Detectar si estamos en entorno onpremise
    const isOnPremise = () => {
      // Verificar si estamos en desarrollo o si hay indicadores de onpremise
      return process.env.NODE_ENV === 'development' || 
             process.env.REACT_APP_ONPREMISE === 'true' ||
             window.location.hostname === 'localhost' ||
             window.location.hostname === '127.0.0.1' ||
             window.location.hostname.includes('54.162.186.44');
    };

    // Si estamos en onpremise, saltar la validación del token
    if (isOnPremise()) {
      logger.info('🏠 OnPremise environment detected - skipping token validation');
      return;
    }

    const accessToken = localStorage.getItem(AUTH_STORAGE_KEY);
    
    if (!accessToken) {
      logger.warn('🔒 No hay token de acceso - redirigiendo al login');
      navigate('/login');
      return;
    }

    // Verificar si el token no está expirado
    try {
      const decoded = JSON.parse(atob(accessToken.split('.')[1]));
      const currentTime = Date.now() / 1000;
      
      if (decoded.exp && decoded.exp < currentTime) {
        logger.warn('🔒 Token expirado - redirigiendo al login');
        localStorage.removeItem(AUTH_STORAGE_KEY);
        localStorage.removeItem('refreshToken');
        navigate('/login');
        return;
      }
    } catch (error) {
      logger.warn('🔒 Token inválido - redirigiendo al login');
      localStorage.removeItem(AUTH_STORAGE_KEY);
      localStorage.removeItem('refreshToken');
      navigate('/login');
      return;
    }

  }, [navigate]);
};